import { Pipe, PipeTransform } from '@angular/core';
import { SharedCommonUtility } from '../../../shared/utils/common.utility';

@Pipe({
  name: 'notNullish',
  standalone: false,
})
export class NotNullishPipe implements PipeTransform {
  transform(value: any, ...args: unknown[]): boolean {
    return SharedCommonUtility.notNullish(value);
  }
}
